import React, { useState } from 'react'
import {DatePicker} from 'antd'
import {useLayout} from '../../../_payairo/layout/core'
import {useLocation} from 'react-router-dom'
import clsx from 'clsx'

const { RangePicker } = DatePicker

const DashboardRightToolbar = () => {
  const {dashboardDateFilter, setDashboardDateFilter} = useLayout()
  const location = useLocation()
  const isDashboard = location.pathname.includes('/dashboard')
  
  let globalMode = dashboardDateFilter || 'Daily'

  const isCustomMode = globalMode.includes(',')
  const [showPicker, setShowPicker] = useState(isCustomMode)

  const handleModeChange = (mode: string) => {
    if (mode === 'Custom') {
      setShowPicker(true)
      // We don't set dashboardDateFilter here yet, wait for date selection
    } else {
      setShowPicker(false)
      setDashboardDateFilter(mode)
    }
  }

  const handleDateChange = (dates: any, dateStrings: [string, string]) => {
    if (dateStrings[0] && dateStrings[1]) {
      setDashboardDateFilter(`${dateStrings[0]},${dateStrings[1]}`)
    }
  }

  const modes = ['Daily', 'Weekly', 'Monthly', 'All', 'Custom']

  return (
    <>
      <div className='d-flex align-items-center gap-3'>
        {showPicker && (
          <RangePicker 
            style={{ borderRadius: '8px', border: '1px solid #E2E8F0', height: '36px' }}
            onChange={handleDateChange as any}
          />
        )}
        <div className='btn-group' role='group' style={{ border: '1px solid #E2E8F0', borderRadius: '8px', padding: '2px', backgroundColor: '#FFFFFF' }}>
          {modes.map((mode) => {
            const isActive = mode === 'Custom' ? isCustomMode || showPicker : globalMode === mode
            return (
              <button
                key={mode}
                type='button'
                className={clsx('btn btn-sm py-1.5 px-4 fs-8 fw-bold transition-all', {
                  'btn-primary shadow-xs': isActive,
                  'btn-color-gray-600 btn-active-color-primary': !isActive,
                })}
                style={{
                  borderRadius: '6px',
                  minWidth: '65px',
                  backgroundColor: isActive ? '#0070F3' : 'transparent',
                  border: 'none',
                  color: isActive ? '#FFFFFF' : '#5E6278',
                }}
                onClick={() => handleModeChange(mode)}
              >
                {mode}
              </button>
            )
          })}
        </div>
      </div>
    </>
  )
}

export default DashboardRightToolbar
